import { makeStyles } from '@fluentui/react';



export const getTextFieldStyles = makeStyles((theme) => ({
    root: {
        width: 400,
    },
}));
